/**
 * StatusBadgeChange — before → after pill rendered after mark_deal_status.
 *
 * HANDOFF_AI_CHAT_FEATURE_V1_REVISED visual-feedback addendum (S19).
 */
import { ArrowRight } from 'react-feather';

import { Badge } from '../../../components/ui';
import type { ToolResultProps } from '../lib/component-registry';

interface StatusResult {
  deal_id: number;
  old_label: string | null;
  new_label: string;
}

export function StatusBadgeChange({ result }: ToolResultProps) {
  const r = (result ?? {}) as Partial<StatusResult>;
  if (!r || !r.new_label) {return null;}
  return (
    <div className="mt-2 flex items-center gap-2 text-body-sm">
      {r.old_label ? (
        <Badge variant="neutral">{prettify(r.old_label)}</Badge>
      ) : (
        <span className="text-txt-tertiary">No status</span>
      )}
      <ArrowRight size={14} className="text-txt-tertiary" />
      <Badge variant="info">{prettify(r.new_label)}</Badge>
    </div>
  );
}

function prettify(label: string): string {
  return label.replace(/_/g, ' ');
}
